<lib-dialog yesText="Save" [onOkay]="save" [width]="450">
  <ng-template>
    <div class="container">
      <address-editor *ngIf="visibleField === 'address'" [address]="addressHelper"> </address-editor>
      <div class="name-row" *ngIf="visibleField === 'name'">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>First Name</mat-label>
          <input
            matInput
            forbidAngleBrackets
            type="text"
            [formControl]="profileForm.controls.firstName"
            placeholder="Required"
            id="first-name-input"
          />
          <mat-error *ngIf="profileForm.controls.firstName.hasError('required')"> First Name is required </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Middle Name</mat-label>
          <input matInput forbidAngleBrackets type="text" [formControl]="profileForm.controls.middleName" />
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Last Name</mat-label>
          <input
            matInput
            forbidAngleBrackets
            type="text"
            [formControl]="profileForm.controls.lastName"
            placeholder="Required"
            id="last-name-input"
          />
          <mat-error *ngIf="profileForm.controls.lastName.hasError('required')"> Last Name is required </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" class="suffix">
          <mat-label>Suffix</mat-label>
          <input matInput forbidAngleBrackets type="text" [formControl]="profileForm.controls.suffix" />
          <mat-error *ngIf="profileForm.controls.suffix.hasError('maxlength')"
            >Suffix is limited to 15 characters.</mat-error
          >
        </mat-form-field>
      </div>
      <lib-phone [formGroup]="profileForm" [isSmallLabel]="true" *ngIf="visibleField === 'phoneNumber'"></lib-phone>
      <mat-form-field appearance="outline" floatLabel="always" *ngIf="visibleField === 'jobTitle'">
        <input autoFocus matInput forbidAngleBrackets [formControl]="profileForm.controls.jobTitle" />
        <mat-error *ngIf="profileForm.controls.jobTitle.hasError('notEmpty')">
          {{ profileForm.controls.jobTitle.getError('notEmpty') }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always" *ngIf="visibleField === 'company'">
        <input autoFocus matInput forbidAngleBrackets [formControl]="profileForm.controls.company" />
        <mat-error *ngIf="profileForm.controls.company.hasError('notEmpty')">
          {{ profileForm.controls.company.getError('notEmpty') }}
        </mat-error>
      </mat-form-field>
    </div>
  </ng-template>
</lib-dialog>
<!--address had error modal. correctedAddress or !correctedAddress-->
<app-address-warning-dialog (useAddress)="useAddress($event)"></app-address-warning-dialog>
